import React from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const Chart = ({options, callback}) => {
  Highcharts.setOptions({
    lang: {
      thousandsSep: ','
    }
  });
  return (<HighchartsReact highcharts={Highcharts} options={options} callback={callback} />);
}

Chart.propTypes = {
  highcharts: PropTypes.object,
  options: PropTypes.object,
}

export default Chart